<template>
  <div class="news-content" v-loading="!data.title">
    <template v-if="data.title">
      <div class="container">
        <el-breadcrumb class="breadcrumb pc" separator=">">
          <el-breadcrumb-item :to="{ path: '../../../portal' }">
            <i class="iconfont iconyemiandaohang-shouye"></i>首页
          </el-breadcrumb-item>
          <el-breadcrumb-item
            :to="{ path: '../../../teacherContent/' + this.teacherId }"
          >{{ teacherName }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '../' + this.type }">{{ getTypeName() }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ data.title }}</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="rich-text-wrapper card-shadow content">
          <h1>{{ data.title }}</h1>
          <div class="info">发布时间：{{ data.updateTime }}</div>
          <div class="rich-text" v-html="data.content"></div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { teacherNewsContent, teacherContent } from "@/api/api.js";

export default {
  name: "teacherNewsContent",
  props: {
    teacherId: {
      type: String,
      default: "0"
    },
    type: {
      type: String,
      default: "1"
    },
    id: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      teacherName: "",
      data: {},
      news: []
    };
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      //监听路由是否变化
      this.init();
    }
  },
  methods: {
    init() {
      teacherContent(this.teacherId)
        .then(res => {
          // 返回数据
          this.teacherName = res.info.name;
        })
        .catch(err => {
          // 异常情况
          console.log(err);
        });

      this.getNews();
    },
    getNews() {
      teacherNewsContent(this.id)
        .then(res => {
          // 返回数据
          this.data = res;
        })
        .catch(err => {
          // 异常情况
          console.log(err);
        });
    },
    getTypeName() {
      let name = "";

      switch (this.type) {
        case "1":
          name = "近期动态";
          break;
        case "2":
          name = "理论文章";
          break;
        case "3":
          name = "媒体关注";
          break;
      }

      return name;
    }
  }
};
</script>

<style scoped>
.breadcrumb {
  margin-top: 20px;
}

.breadcrumb .iconfont {
  margin-right: 2px;
  font-size: 14px;
}

.content {
  margin-top: 20px;
  margin-bottom: 80px;
}

.rich-text-wrapper {
  padding: 30px;
  background-color: #fff;
  border: 1px solid #eee;
}

.rich-text-wrapper h1 {
  font-size: 22px;
  line-height: 32px;
}

.rich-text-wrapper .info {
  margin: 20px 0;
  font-size: 12px;
  line-height: 16px;
  color: #888;
}

@media (max-width: 767px) {
  .content {
    margin-top: 15px;
    margin-bottom: 30px;
  }

  .rich-text-wrapper {
    padding: 0;
    background-color: unset;
    border: unset;
  }

  .rich-text-wrapper h1 {
    font-size: 18px;
    line-height: 30px;
  }

  .rich-text-wrapper .info {
    margin: 10px 0;
  }
}
</style>